export default __webpack_public_path__ + "static/media/droit.f708b5b3.png";